/**
 * SPDX-FileCopyrightText: Ferdinand Thiessen <opensource@fthiessen.de>
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
import { translate as t } from '@nextcloud/l10n'

export const CATEGORIES = ['system', 'security', 'accounts'] as const

export const CATEGORY_NAMES = {
	security: t('security_guard', 'Security'),
	system: t('security_guard', 'Server status'),
	accounts: t('security_guard', 'Accounts'),
}

export const NUMERIC_SEVERITY = {
	success: 0,
	info: 1,
	warning: 2,
	error: 3,
}

export const SEVERITY_NAMES = {
	success: t('security_guard', 'Success'),
	info: t('security_guard', 'Information'),
	warning: t('security_guard', 'Warning'),
	error: t('security_guard', 'Error'),
	unknown: t('security_guard', 'Unknown'),
}
/**
 * Maximum number of setup checks to show
 */
export const MAX_ENTRIES_IN_LIST = 6
export const MAX_ENTRIES_IN_LIST_MOBILE = 3
